import { handleActions } from "redux-actions";
import dayjs from "dayjs";

import {
  SET_GOALS_LOADING,
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_ALL_GOALS_SUCCESS,
  FETCH_GOAL_BY_TYPE_SUCCESS,
  SET_TOP_GOALS_LOADING,
  SET_DATE,
  UPDATE_DATE,
  FETCH_UPDATE_GOAL_SUCCESS,
  UPDATE_VIEW
} from "./goalsSagas";

export const initialState = {
  currentUser: {},
  goalsLoading: {
    attendance: true,
    revenue: true,
    memberships: true,
    retention: true,
    daily_pulse: true
  },
  goals: {},
  topGoals: [],
  bottomGoals: [],
  isLoading: true,
  topGoalsLoading: true,
  view: [
    { id: "individual", name: "Individual" },
    { id: "total", name: "Total" }
  ],
  selectedView: { id: "individual", name: "Individual" },
  date: "",
  isCurrentMonth: true
};

const DISPLAY_TOP_GOALS_RULES = {
  1: [1, 0],
  2: [1, 1],
  3: [2, 1],
  default: [2, 2]
};

function getTopAndBottomGoals(data, key = "progress") {
  const allItems = Object.entries(data)
    .filter(([, value]) => Array.isArray(value))
    .flatMap(([sourceKey, arr]) =>
      arr.filter((goal) => goal[key] < 100 && goal.active).map((goal) => ({ ...goal, sourceKey }))
    );

  const sorted = [...allItems].sort((a, b) => a[key] - b[key]);
  const count = sorted.length;

  const [topCount, leastCount] = DISPLAY_TOP_GOALS_RULES[count] || DISPLAY_TOP_GOALS_RULES.default;

  return {
    least_performing: sorted.slice(0, leastCount),
    top_performing: sorted.slice(-topCount).reverse()
  };
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_GOALS_LOADING]: (state, action) => ({
      ...state,
      goalsLoading: { ...state.goalsLoading, ...action.payload }
    }),
    [SET_TOP_GOALS_LOADING]: (state, action) => ({
      ...state,
      topGoalsLoading: action.payload
    }),
    [SET_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [UPDATE_DATE]: (state, action) => {
      const currentDate = dayjs(state.currentUser.calendarEndDate);
      const isCurrentMonth = action.payload
        ? dayjs(action.payload).year() === currentDate.year() &&
          dayjs(action.payload).month() === currentDate.month()
        : false;

      return {
        ...state,
        date: action.payload,
        isCurrentMonth
      };
    },
    [UPDATE_VIEW]: (state, action) => ({
      ...state,
      selectedView: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_ALL_GOALS_SUCCESS]: (state, action) => {
      const { top_performing, least_performing } = getTopAndBottomGoals(state.goals);

      return {
        ...state,
        topGoals: top_performing || state.topGoals,
        bottomGoals: least_performing || state.bottomGoals
      };
    },
    [FETCH_UPDATE_GOAL_SUCCESS]: (state, action) => {
      const [key, updatedGoal] = Object.entries(action.payload)[0];

      const goals = state.goals[key].map((item) =>
        item.id === updatedGoal.id ? updatedGoal : item
      );
      const updatedGoals = { ...state.goals, [key]: goals };

      const { top_performing, least_performing } = getTopAndBottomGoals(updatedGoals);

      return {
        ...state,
        goals: updatedGoals,
        topGoals: top_performing || state.topGoals,
        bottomGoals: least_performing || state.bottomGoals
      };
    },
    [FETCH_GOAL_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      goals: { ...state.goals, ...action.payload.goals } || state.goals
    })
  },
  initialState
);
